import { Fireworks } from '../../fireworks/index.es';

const fireworksOptions = {
    autoresize: true,
    // opacity: editable as "burn-in" (longer fade)
    opacity: 0.2,
    acceleration: 1.05,     // initial rocket acceleration
    friction: 0.97,         // slow down of our explosion particles
    // gravity: editable as gravity
    gravity: 0.2,
    // particles: editable as "explosion-particles" (number of particles in explosion) min 20, max 100
    particles: 35,
    randomiseExplosionParticleLook: false,
    // editable as trail-length
    traceLength: 3,
    // traceSpeed: editable as "rocket-speed" (speed of rockets) min 3, max 15
    traceSpeed: 10,
    // explosion: editable as "explosion-trail" (length of explosion) min 1, max 10
    explosion: 4,   // Explosion trail length
    explosionSpread: {min: 1.5, max: 2.5}, // How far particles spread out
    intensity: 30,
    // editable as "flickering"
    flickering: 0,
    lineStyle: 'round',
    // Hue, saturation are derived from the colours
    hue: {
        min: 360,
        max: 360
    },
    saturation: {
        min: 100,
        max: 100
    },
    delay: {
        min: 30,
        max: 60
    },
    // Editable as launch width / launch offset
    rocketsPoint: {
        min: 20,        // Where they fly from
        max: 80
    },
    lineWidth: {
        explosion: {
            min: 3,
            max: 4
        },
        trace: {
            min: 2,
            max: 4
        }
    },
    brightness: {
        min: 80,
        max: 100
    },
    // Editable as linger / linger variation
    decay: {
        min: 0.005,    // high means faster decay
        max: 0.01
    },
    mouse: {
        click: false,
        move: false,
        max: 1
    }
};

const FireWorksController = {
    inited: false,
    running: false,
    fireworkControllers: [],

    init: (canvas = null) => {
        if (!FireWorksController.inited) {
            if (canvas === null) {
                canvas = document.getElementById('fireworks_canvas');
            }
            if (canvas) {
                const fWork = new Fireworks(
                    canvas,
                    fireworksOptions,
                    /* {}, 
                    // Let's not do any auto fading
                    false,
                    // A render callback on the first controller to apply the fade effect
                    i === 0 ? 
                        (instance) => {
                            if (instance === this.fireworksControllers[0] && instance.applyFadeEffect) {
                                // console.log('Fireworks applyFadeEffect', instance, this.fireworksControllers[0]);
                                instance.applyFadeEffect();
                            }
                        }
                    : (instance) => {},
                    // Set firework controller 0 as the master so we can manually control the canvas fading (this is an optimisation)
                    // This requires manually calling applyFadeEffect() on the first controller + start() and stop() at the right time.
                    i === 0,
                    this.playRocketExplodeSound */
                );
                FireWorksController.fireworkControllers.push(fWork);
                // console.log('Fireworks inited', FireWorksController.fireworkControllers);
                FireWorksController.inited = true;
            }
        }
    },
    start: () => {
        if (FireWorksController.running) {
            return;
        }
        if (!FireWorksController.inited) {
            FireWorksController.init();
        }
        if (!FireWorksController.inited) {
            console.warn('Fireworks not inited');
            return;
        }
        FireWorksController.fireworkControllers[0].start();
        FireWorksController.running = true;
        FireWorksController.launchFireworks();
    },
    launchFireworks: (count = 1) => {
        if (!FireWorksController.running) {
            return;
        }

        if (!document.hidden) {
            for (let i = 0; i < count; i++) {
                FireWorksController.f = Math.floor(Math.random() * FireWorksController.fireworkControllers.length);
                FireWorksController.fireworkControllers[Math.floor(FireWorksController.f)].launch(1);
                // console.log('Fireworks launched', FireWorksController.fireworkControllers[Math.floor(FireWorksController.f)]);
            }
        }

        const timeoutDelayMult = 0.5 + (Math.random() * 0.75);
        FireWorksController.nextFireworkTimeoutId = setTimeout(() => {
            FireWorksController.launchFireworks();
        }, 200 + (150 * timeoutDelayMult) + Math.random() * 800 * timeoutDelayMult);
    },
    stop: () => {
        if (!FireWorksController.inited) {
            console.warn('Fireworks not inited');
            return;
        }
        FireWorksController.fireworkControllers[0].stop();
        FireWorksController.running = false;
    },
};

export default FireWorksController;
